import {
    createContext,
    Dispatch,
    ReactNode,
    SetStateAction,
    useContext,
    useEffect,
    useRef,
    useState,
} from 'react';

type ContextProps = {
	donVatTuList: any[];
	setDonVatTuList: Dispatch<SetStateAction<any[]>>;
	donVatTuDetail: any;
	setDonVatTuDetail: Dispatch<SetStateAction<any>>;
	donVatTuSelectedIndex: number;
	setDonVatTuSelectedIndex: Dispatch<SetStateAction<number>>;
	actionsRef: React.MutableRefObject<any>;
};

type ContextProviderProps = {
	children: ReactNode;
	initialValues: {
		initialDonVatTuList: any[];
		setDonVatTuList: Dispatch<SetStateAction<any[]>>
	};
};

const initialContextValues: ContextProps = {
	donVatTuDetail: null,
	donVatTuList: [],
	setDonVatTuList: () => {},
	donVatTuSelectedIndex: 0,
	setDonVatTuDetail: () => {},
	setDonVatTuSelectedIndex: () => {},
	actionsRef: {
		current: {}
	}
};

const TabVatTuContext = createContext<ContextProps>(initialContextValues);

export const TabVatTuContextProvider = ({
	children,
	initialValues: { 
		initialDonVatTuList,
		setDonVatTuList
	},
}: ContextProviderProps) => {
	const [donVatTuDetail, setDonVatTuDetail] = useState<any>();
	const [donVatTuSelectedIndex, setDonVatTuSelectedIndex] = useState<number>(0);
	const actionRef = useRef<any>();

	useEffect(() => {
		if (!initialDonVatTuList.length) {
			setDonVatTuDetail({});
			return;
		}
	}, [initialDonVatTuList.length]);

	return (
		<TabVatTuContext.Provider
			value={{
				donVatTuList: initialDonVatTuList,
				setDonVatTuList,
				donVatTuDetail,
				setDonVatTuDetail,
				donVatTuSelectedIndex,
				setDonVatTuSelectedIndex,
				actionsRef: actionRef
			}}
		>
			{children}
		</TabVatTuContext.Provider>
	);
};

export const useTabVatTuContext = () => useContext(TabVatTuContext);
